import {
  Box,
  Button,
  Card,
  InputAdornment,
  MenuItem,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import AdornedInput from "../../../../../components/AdornedInput";
import TextFieldDebouncedNoInitialLoad from "../../../../../components/TextFieldDebouncedNoInitialLoad";
import {
  currencyFormatNoDecimals,
  toTwoDecimals,
} from "../../../../../components/NewDetail/calculations/utils";
import { useTheme } from "@emotion/react";
import AdornedInputDebouncedNoInitialLoad from "../../../../../components/AdornedInputDebouncedNoInitialLoad";

const FlatSheet = ({ quoteFlatSheetCost, flatSheet, onUpdateFlatSheet }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box>
      <Typography sx={{ flex: 1 }} variant="h6">
        Flat Sheet
        {flatSheet.totalSellPrice !== undefined &&
        flatSheet.totalSellPrice !== null
          ? ` - ${currencyFormatNoDecimals(
              Math.round(Number(flatSheet.totalSellPrice ?? 0))
            )}`
          : ""}
      </Typography>
      <Box sx={{}}>
        <Box
          sx={{
            display: "flex",
            flexDirection: isMediumScreen ? "column" : "row",
          }}
        >
          <Box sx={{}}>
            <Typography>Details</Typography>
            <Box
              sx={{ marginTop: "8px", display: "flex", flexDirection: "row" }}
            >
              <TextFieldDebouncedNoInitialLoad
                sx={{
                  width: "150px",
                }}
                onFocus={(e) => e.target.select()}
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                size="small"
                label="Quantity"
                value={
                  flatSheet.quantity ? parseFloat(flatSheet.quantity) : null
                }
                onChange={(e) => {
                  onUpdateFlatSheet({
                    ...flatSheet,
                    quantity: e.target.value,
                  });
                }}
              />
              <TextField
                sx={{
                  width: "150px",
                  marginLeft: "8px",
                }}
                select
                variant="outlined"
                label="Width (in.)"
                id="width"
                name="Width (in.)"
                size="small"
                value={flatSheet.width ? parseFloat(flatSheet.width) : null}
                onChange={(e) => {
                  onUpdateFlatSheet({
                    ...flatSheet,
                    width: e.target.value,
                  });
                }}
              >
                <MenuItem value={40}>40"</MenuItem>
                <MenuItem value={48}>48"</MenuItem>
              </TextField>
            </Box>
          </Box>
          <Box sx={{ marginLeft: isMediumScreen ? 0 : "8px" }}>
            <Typography>Cost Breakdown</Typography>
            <Box
              sx={{ marginTop: "8px", display: "flex", flexDirection: "row" }}
            >
              <AdornedInputDebouncedNoInitialLoad
                sx={{ width: "150px" }}
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Cost Per Flat Sheet"
                value={flatSheet.flatSheetCalculations?.costPerFlatSheet}
                isOveridden={
                  flatSheet.overrides &&
                  flatSheet.overrides.cost_per_piece !== null &&
                  flatSheet.overrides.cost_per_piece !== undefined
                }
                onChange={(e) => {
                  let overridesCopy = flatSheet.overrides ?? {};
                  let overrides = {
                    ...overridesCopy,
                    cost_per_piece: parseFloat(e.target.value),
                  };

                  onUpdateFlatSheet({
                    ...flatSheet,
                    overrides,
                  });
                }}
                handleReset={() => {
                  let overrides = {
                    ...flatSheet.overrides,
                    cost_per_piece: null,
                  };
                  onUpdateFlatSheet({
                    ...flatSheet,
                    overrides,
                  });
                }}
                symbol="$"
                position="start"
              />
              <TextField
                sx={{ flex: 1, maxWidth: "150px", marginLeft: "8px" }}
                disabled
                size="small"
                type="number"
                onFocus={(e) => e.target.select()}
                label="Total Flat Sheet Cost"
                value={flatSheet.flatSheetCalculations.materialCost}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Box>
        </Box>
        <Box>
          <Typography>Pricing</Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: isMediumScreen ? "column" : "row",
              marginTop: "8px",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <TextFieldDebouncedNoInitialLoad
                sx={{ flex: 1, maxWidth: "150px" }}
                size="small"
                type="number"
                onFocus={(e) => e.target.select()}
                label="GP %"
                value={
                  flatSheet.variables?.gross_profit_margin
                    ? toTwoDecimals(
                        flatSheet.variables?.gross_profit_margin * 100.0
                      )
                    : 0
                }
                onChange={(e) => {
                  let variables = {
                    ...flatSheet.variables,
                    gross_profit_margin: Number(e.target.value ?? 0) / 100.0,
                  };
                  onUpdateFlatSheet({
                    ...flatSheet,
                    variables,
                  });
                }}
                //   onChange={(e) => {
                //     e.target.value = parseFloat(
                //       parseFloat(e.target.value).toFixed(4) / 100.0
                //     ).toFixed(4);
                //     handleChange("gross_profit_margin")(e);
                //   }}
                //   isOveridden={overrides?.gross_profit_margin}
                //   handleReset={resetOverride("gross_profit_margin")}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" sx={{ marginRight: "4px" }}>
                      %
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                sx={{
                  flex: 1,
                  maxWidth: "150px",
                  marginLeft: "8px",
                }}
                size="small"
                disabled
                type="number"
                onFocus={(e) => e.target.select()}
                label="Gross Profit"
                value={flatSheet.flatSheetCalculations.grossProfitDollars}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="Start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                marginTop: isMediumScreen ? "8px" : 0,
                marginLeft: isMediumScreen ? 0 : "8px",
              }}
            >
              <AdornedInputDebouncedNoInitialLoad
                sx={{ width: "150px" }}
                disabled
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Final Sale Price"
                value={toTwoDecimals(
                  flatSheet.totalSellPrice ? flatSheet.totalSellPrice : 0
                )}
                isOveridden={
                  flatSheet.overrides &&
                  flatSheet.overrides.total_sell_price !== null &&
                  flatSheet.overrides.total_sell_price !== undefined
                }
                handleReset={() => {
                  let overrides = {
                    ...flatSheet.overrides,
                    total_sell_price: null,
                  };
                  onUpdateFlatSheet({
                    ...flatSheet,
                    overrides,
                  });
                }}
                symbol="$"
                position="start"
              />
              <TextField
                sx={{ flex: 1, maxWidth: "150px", marginLeft: "8px" }}
                size="small"
                disabled
                type="number"
                onFocus={(e) => e.target.select()}
                label="Price Per Flat Sheet"
                value={flatSheet.pricePerPiece}
                symbol="$"
                position="start"
                InputProps={{
                  readOnly: true,
                  disableUnderline: true,
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FlatSheet;
